import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { PackagingProduct, CheckDuplicatePackagingProduct } from 'models';
import { PackagingProductService } from 'services';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PackagingProductEdit {
  private packgaingProduct = new PackagingProduct();
  protected title = '';

  protected ready = false;
  protected id: number | undefined = undefined;

  protected checkDuplicateData: CheckDuplicatePackagingProduct = new CheckDuplicatePackagingProduct();

  constructor(
    private packaginProductService: PackagingProductService,
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  protected activate(params: { Id: number | 'new' }) {
    const id = +params?.Id;
    if (!isNaN(id)) {
      this.id = id;
    }
    void this.getPackagingProduct();
  }

  protected async getPackagingProduct() {
    try {
      if (this.id) {
        this.packgaingProduct = await this.packaginProductService.get(this.id);
        this.title = `${this.packgaingProduct.Name}`;
      } else {
        this.title = `general.newPackagingProduct`;
      }
    } catch (error) {
      this.errorService.handleError(error);
    }
    this.ready = true;
  }

  protected async create() {
    try {
      if (await this.checkDuplicate()) return;

      const type = await this.packaginProductService.post(this.packgaingProduct);
      this.eventAggregator.publish('packagingProductListReset', 1);
      this.toastService.showSuccess('packagingProduct.created');
      this.router.navigateToRoute('service-packaging-product-list');
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async update() {
    try {
      if (await this.checkDuplicate()) return;

      await this.packaginProductService.put(this.packgaingProduct, this.packgaingProduct.Id);
      this.eventAggregator.publish('packagingProductListReset', 1);
      this.toastService.showSuccess('packagingProduct.updated');
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  protected async save() {
    if (this.id) {
      await this.update();
    } else {
      await this.create();
    }
  }

  protected async checkDuplicate() {
    if (this.id) this.checkDuplicateData.Id = this.packgaingProduct.Id;
    this.checkDuplicateData.ProductId = this.packgaingProduct.ProductId;
    const { IsDuplicate } = await this.packaginProductService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('packagingProductIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
